<template>
  <div class="card-body">
    <div class="alert alert-primary alert-info" role="alert" v-if="partnerInternal.partnerTarafTypeId == 1">
      <i class="fal fa-info-circle"></i><span class="mr-2">تم تعيين بيانات هذا الطرف باعتباره الطرف الأول في
        العقد</span>
    </div>
    <div v-if="isVerify">
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent>
          <div class="form-row">
            <div class="col-md-4">
              <ValidationProvider name="select" rules="required" v-slot="{ errors }">
                <label for="inputEmail4" class="pb-2">نوع الهوية<i class="required-astrisk">*</i></label>
                <v-select :items="socialIdTypeItems" v-model="partnerInternal.socialTypeId" item-text="name"
                  item-value="id" :error-messages="errors" label="اختر نوع الهوية" required solo></v-select>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <NationalIdComponent isRequired="true" v-bind:inputValue.sync="socialId"
                :isIqama="partnerInternal.socialTypeId === 2" :key="partnerInternal.socialTypeId">
              </NationalIdComponent>
            </div>
            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" name="birthdate" rules="required|date|lessThan18">
                <v-input :error-messages="errors" v-model="birthDate">
                  <DropDownCalendarComponent :isRequired="true" label="تاريخ الميلاد" :yearsCount="100"
                    :isGregorian="false" @dateChanged="onChangedDate">
                  </DropDownCalendarComponent>
                </v-input>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <label for="inputEmail4" class="pb-2">رقم الجوال<i class="required-astrisk">*</i></label>
              <MobileComponent v-model="mobileNumber" :isCheckDuplicate="true"
                @mobileDuplicationValidated="mobileDuplicationValidated"
                hint="سيتم إرسال الاشعارات على رقم الجوال المسجل في أبشر" persistent-hint></MobileComponent>
            </div>
            <div v-if="tarafType == 3 && hasLawyer" class="col-md-4">
              <NumberComponent v-bind:inputValue.sync="partnerInternal.licenseNumber" label="رقم رخصة المحاماة"
                placeholder="رخصة المحامي" name="lawyerLicenseNo"></NumberComponent>
            </div>
            <div class="col-md-4 mt-8">
              <button type="submit" class="btn button--greenFill px-8" @click="handleSubmit(verifyUser)">تحقق</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import { PartnerApprovalHistoryModel } from '@/models/partnerApprovalHistoryModel';
import { DDCalendarDate } from '@/models/common';
import NumberComponent from '@/components/number.component.vue';
import { PartnerApprovalEnum } from '@/enums/partnerApprovalEnum';

//@ts-ignore
import momenthijri from 'moment-hijri';
import { Toaster } from '../../services/toast';
import { PersonInfoModel } from '@/models/PersonInfoModel';
import { PersonInfoRequestModel } from '@/models/PersonInfoRequestModel';
import { ContractPartnerModel } from '@/models/contractPartnerModel';
import UserModel from '@/models/user';
import ExternalService from '@/services/external';
import UserService from '@/services/user';
import { moduleProxy } from '@/store';
import { DateTimeHelper } from '@/utils/date-time.helper';
import DropDownCalendarComponent from '../dropDownCalendar.vue';
import MobileComponent from '../mobile.component.vue';
import NationalIdComponent from '../nationalId.component.vue';
import { CreateContractModel } from '@/models/contractDetailsModel';
import { TarafTypeEnum } from '@/enums/tarafTypeEnum';

@Component({
  components: {
    NationalIdComponent,
    MobileComponent,
    DropDownCalendarComponent,
    NumberComponent,
  },
  diProvide: [
    ExternalService, UserService,
  ],
})
export default class TarafComponent extends Vue {
  @Inject(ExternalService) public externalService!: ExternalService;
  @Inject(UserService) public userService!: UserService;
  @Prop({ default: { socialTypeId: 1 } as ContractPartnerModel }) partner!: ContractPartnerModel;
  @Prop() tarafType!: number;
  currentUser = {} as UserModel;
  partnerInternal: ContractPartnerModel = { socialTypeId: 1 } as ContractPartnerModel;
  contractModel = {} as CreateContractModel;
  socialId = '';
  mobileNumber = '';
  birthDate = '';
  caledarDate = {} as DDCalendarDate;
  isVerify = true;
  socialIdTypeItems = [{ id: 1, name: 'هوية وطنية' }, { id: 2, name: 'إقامة' }];
  selectedSocialType = null;
  isIqama = true;
  personInfoRequestModel: PersonInfoRequestModel = {} as PersonInfoRequestModel;
  isMobileDuplicated = false;

  mounted() {
    this.contractModel = moduleProxy.Contract.getContract;
    if (this.partner && this.partner != null && this.partner.socialId) {
      this.partnerInternal = this.partner;
      this.setPartnerTarafType(); // in case user changed first partner taraf type
    } else {
      this.setPartnerTarafType();
    }

    this.partnerInternal.approvalStatusId = PartnerApprovalEnum.Pending;
    this.partnerInternal.najizApprovalHistory = [{ statusId: PartnerApprovalEnum.Pending }] as PartnerApprovalHistoryModel[];
  }

  @Watch('mobileNumber')
  watchmobileNumber() {
    this.partnerInternal.mobileNumber = this.mobileNumber;
  }

  @Watch('partnerInternal.socialTypeId')
  watchSocialTypeId() {
    if (this.partnerInternal?.socialTypeId === 1) { // هوية وطنية
      this.isIqama = false;
    } else {
      this.isIqama = true;
    }
  }

  @Watch('partner')
  watchPartner() {
    this.partnerInternal = this.partner;
    this.partnerInternal.approvalStatusId = PartnerApprovalEnum.Pending;
    this.partnerInternal.najizApprovalHistory = [{ statusId: PartnerApprovalEnum.Pending }] as PartnerApprovalHistoryModel[];
  }

  verifyUser() {
    // Check is mobile duplicated with other partners.
    if (!this.isMobileDuplicated && this.checkPartner(this.socialId)) {
      if (this.$refs.form) {
        (this.$refs.form as any).validate().then((success: boolean) => {
          // TODO: Find a proper way to handle form validation.
          if (!success || (this.birthDate === '' && this.isVerify)) return;

          this.getNICUserInfo();
        });
      }
    }
  }

  getNICUserInfo() {
    const nationalid = this.socialId;
    const dateList = this.birthDate.split('-');
    let personInfoRequestModel = {
      nationalId: nationalid,
      year: dateList[0],
      month: dateList[1],
      day: dateList[2],
    } as PersonInfoRequestModel;

    if (this.partnerInternal?.licenseNumber) {
      personInfoRequestModel = {
        nationalId: nationalid,
        year: dateList[0],
        month: dateList[1],
        day: dateList[2],
        licenseNumber: this.partnerInternal?.licenseNumber,
      } as PersonInfoRequestModel;
    }

    this.externalService.getPersonInfo(personInfoRequestModel).then((response) => {
      this.mapPartnerData(response.model);
    });
  }

  mapPartnerData(user: PersonInfoModel) {
    if (user?.data?.length > 0) {
      const { person } = user.data[0];
      const license = this.partnerInternal.licenseNumber;
      this.partnerInternal = person as any;
      this.partnerInternal.socialId = person.id;
      this.partnerInternal.gender = person.sexCode;
      this.partnerInternal.genderDesc = person.sexDescAr;
      this.partnerInternal.nationalityName = person.nationalityDescAr;
      const selectedHijDate = momenthijri(this.partnerInternal?.birthDate, 'YYYY-MM-DD').format('iYYYY/iMM/iDD');
      this.partnerInternal.birthDateHijri = selectedHijDate;
      this.partnerInternal.mobileNumber = this.mobileNumber;

      if (user.lawyerData) {
        this.partnerInternal.licenseNumber = license;
        this.partnerInternal.licenseStatus = user.lawyerData.status;
        this.partnerInternal.licenceDate = user.lawyerData.licenceDate;
        this.partnerInternal.licenceDateHijri = DateTimeHelper.convertToHijri(user.lawyerData.licenceDateHijri);
        this.partnerInternal.licenceEndDate = user.lawyerData.licenceEndDate;
        this.partnerInternal.licenceEndDateHijri = DateTimeHelper.convertToHijri(user.lawyerData.licenceEndDateHijri);
      }

      this.setPartnerTarafType();
      this.isVerify = false;
      // emit this taraf to parent to be added
      this.partnerInternal.formType = this.tarafType;
      this.partnerInternal.approvalStatusId = PartnerApprovalEnum.Pending;
      this.partnerInternal.najizApprovalHistory = [{ statusId: PartnerApprovalEnum.Pending }] as PartnerApprovalHistoryModel[];
      delete (this.partnerInternal as any).id;
      delete this.partnerInternal.id;
      this.$emit('addActivePartner', this.partnerInternal);
    }
  }

  setPartnerTarafType() {
    if (this.tarafType === 1) { // current form taraf type
      this.partnerInternal.partnerTarafTypeId = 1;
      this.partnerInternal.partnerSefaTypeId = 1;
    } else if (this.tarafType === 2) {
      this.partnerInternal.partnerTarafTypeId = 2;
      this.partnerInternal.partnerSefaTypeId = 1;
    } else { // محامي
      this.partnerInternal.partnerTarafTypeId = 3;
      this.partnerInternal.partnerSefaTypeId = 2;
    }
  }

  onChangedDate(date: DDCalendarDate) {
    this.birthDate = date.gregDate;
  }

  reset() {
    this.isVerify = true; this.birthDate = ''; this.mobileNumber = ''; this.socialId = '';
    moduleProxy.Contract.setContractSecondPartner({} as ContractPartnerModel);
  }

  private checkPartner(socialid: string): boolean {
    const partner = moduleProxy.Contract.getContractPartners.find((x) => x.socialId === socialid);

    if (partner) {
      switch (partner.partnerTarafTypeId) {
        case TarafTypeEnum.FirstPartner:
          Toaster.error({ message: `عذرًا، تم إضافة صاحب الهوية ${partner.socialId} كطرف أول في الطلب سابقًا` });
          break;
        case TarafTypeEnum.SecondPartner:
          Toaster.error({ message: `عذرًا، تم إضافة صاحب الهوية ${partner.socialId} كطرف ثاني في الطلب سابقًا` });
          break;
        case TarafTypeEnum.Lawyer:
          Toaster.error({ message: `عذرًا، تم إضافة صاحب الهوية ${partner.socialId} كمحامي في الطلب سابقًا` });
          break;
        default:
          throw new Error('Invalid party type.');
      }

      return false;
    }

    return true;
  }

  mobileDuplicationValidated(isDuplicated: boolean) {
    this.isMobileDuplicated = isDuplicated;
  }

  get hasLawyer() {
    return moduleProxy.Contract.getHasLawyer;
  }
}
</script>
